import { FilterOption } from 'stores/types';

export default class FilterValueArray extends Array<FilterOption> {
  constructor(values: FilterOption[] | number) {
    // Base array class has 2 overloads
    // 1. Array(val, val, val) - when values is FilterOption[]
    // 2. Array(number) - when values is number (creates empty array of specified length)

    // This must exist to satisfy the base array class's overloads.
    // FilterValueArray.filter() will attempt to create a new array with the same length as the original array,
    // so we need to handle the case where values is a number.
    if (typeof values === 'number') {
      super(values);
    } else {
      // Always sort items by id or their string representation to ensure consistent ordering for cache consistency
      const sortedValues = [...values].sort((a, b) => {
        const aKey = a.id || String(a);
        const bKey = b.id || String(b);
        return aKey.localeCompare(bKey);
      });
      super(...sortedValues);
    }
    Object.setPrototypeOf(this, FilterValueArray.prototype);
  }

  removeFilter(id: string) {
    return new FilterValueArray(this.filter((filterValue) => filterValue.id !== id));
  }

  serialize() {
    return this;
  }
}
